import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file Mask.tsx
 * @author markJia(markjia@tencent.com)
 */
import React, { useMemo } from 'react';
import { getZIndex } from '@tencent/glue-dom-helper';
var defaultMaskStyle = {
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  background: 'rgba(0, 0, 0, .5)'
};
export var RcMask = function RcMask(props) {
  var _props$show = props.show,
      show = _props$show === void 0 ? false : _props$show,
      className = props.className,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      onClick = props.onClick;
  var zIndex = useMemo(function () {
    return style.zIndex || getZIndex();
  }, [style.zIndex, show]);
  return React.createElement("div", {
    className: className,
    style: _objectSpread(_objectSpread(_objectSpread({}, defaultMaskStyle), style), {}, {
      zIndex: zIndex,
      display: show ? 'block' : 'none'
    }),
    onClick: onClick
  });
};